import {
  SEARCHING,
  SEARCH_FINISHED,
  SEARCH_ERROR,
  GETTING_MORE_DATA,
  GOT_MORE_DATA,
  MORE_DATA_ERROR,
  GOT_DETAILS
} from "../Actions/actionTypes";

import { gotMoreData, updateState } from "../utility";

const initialState = {
  pageNum: 0,
  loading: false,
  moreLoading: false,
  results: {},
  error: null,
  moreError: null
};

export const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCHING:
      return { ...state, loading: action.payload };
    case SEARCH_FINISHED:
      return { ...initialState, results: action.payload, pageNum: 1 };
    case SEARCH_ERROR:
      return { ...state, error: action.payload };
    case GOT_DETAILS:
      return action.payload.type === "search"
        ? updateState(action.payload, state)
        : state;
    case GETTING_MORE_DATA:
      return { ...state, moreLoading: action.payload };
    case GOT_MORE_DATA:
      return gotMoreData(action.payload, state);
    case MORE_DATA_ERROR:
      return { ...state, moreError: action.payload };
    default:
      return state;
  }
};
